import { Icon, IconProps } from '@chakra-ui/react'

export default function AddIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M1.5 9H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16.5V1.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
